import { PopoverController } from '@ionic/angular';
import { LanguageService } from './../language.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language-list',
  templateUrl: './language-list.component.html',
  styleUrls: ['./language-list.component.scss'],
})
export class LanguageListComponent implements OnInit {

  constructor(private lang: LanguageService, private popover: PopoverController) { }

  ngOnInit() {}

  onLangBtnCLicked(langCode: string) {
    this.lang.setLang(langCode);
    this.popover.dismiss();
  }
}
